import {vnModule_knockoutJS} from '../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import {XMLHttpRequestHandler, XMLHttpRequestHandler_requestType} from '../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { accountDashboard_template } from '../components/templates/accountDashboard_template';
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class accountDashboard extends vnModule_knockoutJS{

    protected accountDashboard_template: accountDashboard_template;
    protected XHRHdl: XMLHttpRequestHandler;
    protected urlPath: string;

    /**
     * @inheritDoc
     */
    protected getModuleName(): string{

        return 'accountDashboard';
    }

    /**
     * @inheritDoc
     */
    public buildContent() : Array<Element> {

        let zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle('Accounts Dashboard');

        this.accountDashboard_template = new accountDashboard_template('accountDashboard', this.viewModel, this)
        this.template = this.accountDashboard_template;

        return [this.accountDashboard_template.build()];
    }

    /**
     * @inheritDoc
     */
    public fillPage(): void {

        this.getSearchPresetsListData();
        this.accountDashboard_template.buildDatePickerCalendar();
    }

    protected getListFormData(): void {

        this.loadingIn(this.accountDashboard_template.builtTemplate.querySelector('#accountsTable-results'));

        let subViewModel = this.accountDashboard_template.getViewModelForRequest();

        let usrReq_url: string = '/api/accountDashboard/references/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj): Function {

        return function() {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                //obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.getAccountsTable();
                obj.loadingOut(obj.accountDashboard_template.builtTemplate.querySelector('#accountsTable-results'));
            });
        }
    }

    protected getAccountsTable(resetPagination: boolean = true){

        if (resetPagination) {

            this.accountDashboard_template.getTemplateViewModel().pagination.pageNumber(1);
        }

        this.loadingIn(this.accountDashboard_template.builtTemplate.querySelector('#accountsTable-results'));

        let subViewModel = this.accountDashboard_template.getViewModelForRequest();
        let baseApiUrl = '/api/accountDashboard/tableData/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onGetAccountsTableReturn.bind(this, baseApiUrl, 'getAccountsTable'), XMLHttpRequestHandler_requestType.GET, 'getAccountsTable')
    }

    protected onGetAccountsTableReturn(baseApiUrl, callIdentifier, req, obj) {

        return function (){

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.setResultInfo(baseApiUrl, callIdentifier, responseParsed.totalCount, responseParsed.totalPage);
                obj.accountDashboard_template.getTemplateViewModel().accountsTableData(responseParsed.data);
                obj.accountDashboard_template.pagination.setNumberItemToPaginate(responseParsed.totalCount);
                obj.loadingOut(obj.accountDashboard_template.builtTemplate.querySelector('#accountsTable-results'));
            })
        }
    }

    protected getListDataForCSV(){

        this.loadingIn(this.accountDashboard_template.builtTemplate.querySelector('#accountsTable-results'));

        if( this.XHRHdl ){

            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = this.accountDashboard_template.getViewModelForRequest();
        subViewModel['csvExport'] = true;
        let baseApiUrl = '/api/accountDashboard/tableData/get/';

        this.sendFilterCall(baseApiUrl, subViewModel, this.onCSVDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getListDataForCSV')
    }

    protected onCSVDataRequestReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.exportCsvData(responseParsed);
            });

            obj.loadingOut(obj.accountDashboard_template.builtTemplate.querySelector("#accountsTable-results"));
        };
    }

    protected exportCsvData(exportData): void{

        this.accountDashboard_template.setCsvExportData(exportData);
        this.accountDashboard_template.exportCsvData();
    }    

    protected setResultInfo(baseApiUrl, callIdentifier, totalCount, totalPage){

        let callHdl = this.getXHRHdl(baseApiUrl, callIdentifier);

        let execTime = Math.round((new Date().getTime() - callHdl.requestStartTime)/1000*100)/100;
        this.accountDashboard_template.setResultPage(totalCount, totalPage, execTime);
    }

    private getXHRHdl(baseURl, callIdentifier){

        let callKey =   baseURl + '-' + callIdentifier;

        return this.XHRHdls[callKey];
    }

    protected paginationOnPageClick(){

        this.getAccountsTable(false);
    }

    protected filterDateOnChange(element){

        this.getAccountsTable();
    }

    public onQuit(){

        for(let callKey in this.XHRHdls){

            this.XHRHdls[callKey].cancelAndReset();
        }
    }
}


// WEBPACK FOOTER //
// ./js/modules/accountDashboard.ts